module.exports = __webpack_public_path__ + "src/assets/img/bankid_black.cdda0d76.svg";